import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function Register() {
	const { register } = useAuth()

	const [username, setUsername] = useState('')
	const [email, setEmail]       = useState('')
	const [password, setPassword] = useState('')
	const [confirm, setConfirm]   = useState('')
	const [error, setError]       = useState('')
	const [success, setSuccess]   = useState('')
	const [loading, setLoading]   = useState(false)

	async function handleSubmit(e) {
		e.preventDefault()
		setError('')
		if (password !== confirm) { setError('Passwords do not match'); return }
		setLoading(true)
		try {
			const msg = await register(username, email, password)
			setSuccess(msg)
		} catch (err) {
			setError(err.message)
		} finally {
			setLoading(false)
		}
	}

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>Create an account</h2>

				{error   && <div className='authError'>{error}</div>}
				{success && <div className='authSuccess'>{success}</div>}

				{!success && (
					<form onSubmit={handleSubmit}>
						<div className='authField'>
							<label>Username <small>(3-30 characters, letters, numbers, _ or -)</small></label>
							<input
								type='text'
								value={username}
								onChange={e => setUsername(e.target.value)}
								required
								minLength={3}
								maxLength={30}
								pattern='[a-zA-Z0-9_\-]+'
								title='Letters, numbers, underscores and hyphens only'
								autoFocus
							/>
						</div>
						<div className='authField'>
							<label>Email</label>
							<input
								type='email'
								value={email}
								onChange={e => setEmail(e.target.value)}
								required
							/>
						</div>
						<div className='authField'>
							<label>Password <small>(8 characters minimum)</small></label>
							<input
								type='password'
								value={password}
								onChange={e => setPassword(e.target.value)}
								required
								minLength={8}
							/>
						</div>
						<div className='authField'>
							<label>Confirm password</label>
							<input
								type='password'
								value={confirm}
								onChange={e => setConfirm(e.target.value)}
								required
							/>
						</div>
						<button className='authBtn' disabled={loading}>
							{loading ? 'Creating account…' : 'Register'}
						</button>
					</form>
				)}

				<div className='authLinks'>
					<Link to='/login'>Already have an account? Log in</Link>
				</div>
			</div>
		</div>
	)
}

export default Register
